import styled from 'styled-components'
import { Color, MediaBreakpoint } from 'root-constants'
import { Button } from 'components/Button'
import { SecurityInfo } from 'modules/purchase/components/SecurityInfo'
import { Container } from 'components/Container'

export const StyledPurchaseVariant2 = {
  SpinnerBackground: styled.div`
    position: relative;
    background: #f7f4ff;
    height: 100vh;
    z-index: 2;
  `,
  Wrapper: styled.div`
    margin: 0 auto;
    padding-bottom: 20px;
    position: relative;
    background: #f7f4ff;
    z-index: 2;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      background: #f7f4ff;
      height: 100vh;
      width: 100%;
    }
  `,
  Title: styled.h2`
    margin: 16px 0;
    padding: 0 16px;
    max-width: 360px;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: ${Color.DARK};

    & > span {
      color: ${Color.ORANGE};
    }
  `,
  Description: styled.p`
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 40px;
    color: ${Color.DARK};
  `,
  Hero: styled.div`
    position: relative;
    max-width: ${MediaBreakpoint.MAX_PHONE}px;
    margin: 0 auto 24px;
    width: 100%;

    @media screen and (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      max-width: 360px;
    }
  `,
  Received: styled.div`
    margin-bottom: 40px;
    background: #ebe8ff;
    border-radius: 24px;
    overflow: hidden;

    ul {
      padding: 24px 16px;
    }
  `,
  ListItem: styled.li`
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    display: flex;
    align-items: flex-start;
    color: ${Color.DARK};

    svg {
      margin-right: 10px;
      min-width: 30px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  `,
  ListTitle: styled.h2`
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    padding: 24px 16px;
    text-align: center;
    background: ${Color.GRADIENT}, #ffffff;
  `,
  ProgramPlanContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  FeaturedBlockContainer: styled.div`
    margin-bottom: 40px;
  `,
  FeaturedBlockTitle: styled.h2`
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: ${Color.DARK};
    text-align: center;
  `,
  Button: styled(Button)`
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
  SecurityInfo: styled(SecurityInfo)`
    background-color: #ebe8ff;

    & > div {
      background-color: #ebe8ff;
    }

    h2 {
      color: ${Color.DARK};
    }

    p {
      color: #6e7188;
    }
  `,
  Container: styled(Container)`
    margin-top: 40px;
  `,
  BenefitsTitle: styled.h2`
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: ${Color.DARK};
  `,
  Benefits: styled.div`
    padding: 24px 16px;
    background: #ebe8ff;
    border-radius: 24px;
    margin-bottom: 40px;

    h2 {
      margin-bottom: 24px;
    }

    li {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
    }
  `,
  Disclaimer: styled.p`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #babbbc;
    margin-top: 40px;

    a {
      color: #babbbc;
      text-decoration: underline;
    }
  `,
}
